// extracted by mini-css-extract-plugin
export default {"timetableStyle":"styles_timetableStyle__KdP9r","periodName":"styles_periodName__+wT3h","periodCell":"styles_periodCell__GFlxu"};